<div class="change__balance-container">
  <div [class]="!!inputData ? 'change__balance-header p-0' : 'change__balance-header'">
    @if(!inputData){
    <h5 class="flex justify-between items-center gap-2">
      <!-- Update -->
      {{ data?.title ?? inputData?.title }}
      @if(has_api_call){
      <p class="m-0 text-xs font-normal text-[#515765] flex gap-2 items-center">
        Powered by @switch (powered_by) { @case ('Yahoo finance') {
        <img src="/assets/images/yahoo-finance.svg" alt="Yahoo-finance logo icon" class="" />
        } @case ('Principal Api') {
        <img src="/assets/images/principal-api.svg" alt="Principal Api-finance logo icon" class="" />
        <span class="uppercase text-[#53565B] font-semibold text-[12px]"> principal Apis </span>
        } @case ('Live metal') {
        <img src="/assets/images/live-metal.svg" alt="Live metal logo icon" class="" />
        } }
      </p>
      }
    </h5>
    }@else{
    <p class="app__form--attribute--title text-xl font-semibold text-[#53565B] leading-8 whitespace-nowrap w-full mx-6">
      Add <span class="text-[#25508E] whitespace-nowrap">{{ data?.title ?? inputData?.title }}</span> for
      <span class="text-[#25508E] whitespace-nowrap">{{ inputData.form_name }}</span>
      @if(has_api_call){
      <span class="m-0 text-xs font-normal text-[#515765] flex gap-2 items-center">
        Powered by @switch (powered_by) { @case ('Yahoo finance') {
        <img src="/assets/images/yahoo-finance.svg" alt="Yahoo-finance logo icon" class="" />
        } @case ('Principal Api') {
        <img src="/assets/images/principal-api.svg" alt="Principal Api-finance logo icon" class="" />
        <span class="uppercase text-[#53565B] font-semibold text-[12px]"> principal Apis </span>
        } @case ('Live metal') {
        <img src="/assets/images/live-metal.svg" alt="Live metal logo icon" class="" />
        }}
      </span>
      }
    </p>
    } @if(!inputData){
    <div class="web__close-icon">
      <button type="button" class="close" data-dismiss="modal" (click)="closeDialog()">
        <span class="material-icons icons-close-mobile">close</span>
      </button>
    </div>
    }
  </div>

  <div
    [class]="
      !!inputData && (hasYahooApi || hasMetalApi)
        ? 'change__balance-form p-0 setup-max-w change__balance__api-form'
        : !inputData && (hasYahooApi || hasMetalApi)
        ? 'change__balance-form change__balance__api-form'
        : 'change__balance-form'
    "
  >
    <form [formGroup]="premiumForm" #formTemplate>
      @for (control of formKeys;track control.key;let i = $index) {

      <div [class]="i !== 0 ? 'mt-3 relative' : 'relative'">
        @if(control?.type == 'Dollar Input'){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }
        <input-number-effect
          [showLabel]="true"
          [title]="control?.title"
          (newValue)="setValue($event, control?.key)"
          [initial]="control?.value ?? 0"
          [fromAddBalance]="false"
          [fromPurchasePrice]="true"
          [fromPrivateDebt]="false"
          [styledIcon]="true"
          [isNegativeAllowed]="false"
          [hideIcons]="false"
          (click)="(null)"
          [id]="control?.key"
          [focusId]="control?.key"
        >
        </input-number-effect>

        } @if(control?.type == 'Percentage'){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }

        <input-number-effect
          [showLabel]="true"
          [title]="control?.title"
          (newValue)="setValue($event, control?.key)"
          [initial]="control?.value ?? 0"
          [fromAddBalance]="false"
          [fromPurchasePrice]="true"
          [fromPrivateDebt]="false"
          [styledIcon]="true"
          [isNegativeAllowed]="false"
          [hideIcons]="false"
          (click)="(null)"
          [id]="control?.key"
          [focusId]="control?.key"
        >
        </input-number-effect>
        } @if(control?.type === ('Numeric Input')){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }

        <input-number-effect
          [showLabel]="true"
          [title]="control?.title"
          (newValue)="setValue($event, control?.key)"
          [initial]="control?.value ?? 0"
          [fromAddBalance]="false"
          [fromPurchasePrice]="true"
          [fromPrivateDebt]="false"
          [styledIcon]="false"
          [isNegativeAllowed]="false"
          [hideIcons]="true"
          (click)="(null)"
          [id]="control?.key"
          [focusId]="control?.key"
        >
        </input-number-effect>
        } @if(control?.type === ('Numeric Input 2')){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }
        <mat-form-field
          appearance="fill"
          style="width: 100% !important"
          class="automtic-form-desing-form-only add-automtic-form-desing full-width app__attributes-form-field"
        >
          <mat-label class="automtic-form-desing-lable"> {{ control?.title }} </mat-label>
          <input
            matInput
            type="text"
            [formControlName]="control?.key"
            (keyup)="checkInput2($event, control)"
            [id]="control?.key"
            (keydown)="checkInput($event, control)"
          />
        </mat-form-field>
        } @if(control?.type == 'Switch'){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }

        <div class="w-full p-3 rounded-md border border-[#E0DEDF] flex justify-between items-center text-sm font-semibold">
          {{ control?.title }}
          <mat-slide-toggle [formControlName]="control?.key"> </mat-slide-toggle>
        </div>
        } @if (hasCategoryDropDown(control)) { @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }
        <income-expense-dropdown [control]="control" [premiumForm]="premiumForm" #incomeExpenseDropdown></income-expense-dropdown>
        } @if(control?.type == 'Assets & Liabilities'){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }
        <mat-form-field
          appearance="fill"
          style="width: 100% !important"
          class="automtic-form-desing-form-only add-automtic-form-desing full-width app__attributes-form-field"
        >
          <mat-label class="automtic-form-desing-lable"> {{ control?.title }} </mat-label>
          <input matInput type="text" [placeholder]="control.value" [value]="control.value" [formControlName]="control?.key" />
        </mat-form-field>
        } @if(control?.key == 'effective_date' || control?.type == 'Date Selection' || control?.type =="Date" || control?.key == 'as_of'){
        @if(!!control.isNotEditable && control.isNotEditable == 'Not Editable'){
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        <mat-form-field appearance="fill" class="form-design-ui" floatLabel="always">
          <mat-label class="automtic-form-desing-lable"> {{ control?.title }} </mat-label>
          <input matInput value="{{ convertStringToDate(control?.value) }}" />
        </mat-form-field>
        }@else{
        <reusable-date-input
          [classStyle]="'app__attributes-form-field form-design-ui'"
          [title]="control?.title"
          [hasMaxDate]="hasMaxDate"
          [controlName]="control?.key ?? 'effective_date'"
          [maxDate]="maxDate"
          [value]="control?.value"
          (dateChangeEmitter)="handleDateChange($event, control?.key, control)"
          (changeEmitter)="handleDateChange($event, control?.key, control)"
        >
        </reusable-date-input>
        <!-- <mat-form-field appearance="fill" class="form-design-ui">
          <mat-label class="automtic-form-desing-lable"> {{ control?.title }} </mat-label>
          @if(hasMaxDate){
          <input
            #input
            matInput
            [max]="maxDate"
            [matDatepicker]="dp3"
            (click)="dp3.open()"
            (dblclick)="input.focus()"
            [formControlName]="control?.key ?? 'effective_date'"
            (dateChange)="setValue($event.value, control)"
            (change)="handleDateChange($event, control?.key, control)"
          />
          } @else {
          <input
            #input
            matInput
            [matDatepicker]="dp3"
            (click)="dp3.open()"
            (dblclick)="input.focus()"
            [formControlName]="control?.key ?? 'effective_date'"
            (dateChange)="setValue($event.value, control)"
            (change)="handleDateChange($event, control?.key, control)"
          />
          }
          <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
          <mat-datepicker #dp3 disabled="false"></mat-datepicker>
        </mat-form-field> -->

        } } @if(control?.type?.includes('Dropdown')){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }
        <div class="dropdown">
          <mat-form-field
            appearance="fill"
            style="width: 100% !important"
            class="automtic-form-desing-form-only add-automtic-form-desing full-width app__attributes-form-field"
          >
            <mat-label class="automtic-form-desing-lable"> {{ control?.title }} </mat-label>
            <mat-select [formControlName]="control?.key" disableOptionCentering (selectionChange)="setValue($event.value, control)">
              @for (item of handleDropDownTypes(control); track $index) {
              <mat-option [value]="item">
                {{ item }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        } @if(!control?.type.includes('Dropdown') && !!getType(control.type)){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }

        <mat-form-field
          appearance="fill"
          style="width: 100% !important"
          class="automtic-form-desing-form-only add-automtic-form-desing full-width app__attributes-form-field"
        >
          <mat-label class="automtic-form-desing-lable"> {{ control?.title }} </mat-label>
          <mat-select [formControlName]="control?.key" disableOptionCentering (selectionChange)="setValue($event.value, control)">
            @for (item of control.type; track $index) {
            <mat-option [value]="item">
              {{ item }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        } @if(control?.type?.includes('Text Input')){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }
        <mat-form-field appearance="fill" style="width: 100% !important" class="automtic-form-desing-form-only add-automtic-form-desing full-width">
          <mat-label class="automtic-form-desing-lable"> {{ control?.title }} </mat-label>
          <input matInput type="text" [formControlName]="control?.key" />
        </mat-form-field>
        } @if(control?.type?.includes('search')){ @if (!!control.isNotEditable) {
        <div class="bg-k-grey h-full w-full rounded-[4px] absolute z-10 opacity-50"></div>
        }
        <div class="dropdown">
          <mat-form-field
            appearance="fill"
            style="width: 100% !important"
            class="automtic-form-desing-form-only add-automtic-form-desing full-width app__attributes-form-field"
          >
            <mat-label class="automtic-form-desing-lable"> {{ control?.title }} </mat-label>
            <mat-select [formControlName]="control?.key" disableOptionCentering (selectionChange)="setValue($event.value, control)">
              <div class="h-auto max-h-[285px] w-full flex-col">
                <div class="mx-2 my-3 h-10">
                  <div class="income__expense--category--header items-center justify-around h-full">
                    <mat-form-field appearance="fill" class="w-full app__attributes-search-field">
                      <input
                        #myInput
                        matInput
                        type="text"
                        class="w-[80%] pl-[10px] h-full outline-none"
                        autocomplete="off"
                        placeholder="Search"
                        (keydown.space)="$event.stopPropagation()"
                        (click)="$event.stopPropagation()"
                        (input)="handleSearch($event.target.value, control.key === 'ticker_symbol' ? true : false)"
                      />
                    </mat-form-field>
                    <mat-icon class="text-[#C2C3C7]">search</mat-icon>
                  </div>
                </div>

                @for (item of filteredSearchResults; track $index) {
                <mat-option [value]="handleValueForSearch(item?.key, control.key === 'ticker_symbol' ? item.key : item.value)">
                  {{ control.key === 'ticker_symbol' ? item.key : item.value }}
                </mat-option>
                }
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        } @if(control.hasError){
        <p class="m-0 font-semibold text-xs text-[#EB5757] flex items-start gap-2 mt-1">
          <span class="material-icons text-sm"> info_outline</span>
          There was an error fetching the value from @switch (powered_by) { @case ('Yahoo finance') { Yahoo finance } @case ('Principal Api') {
          Principal Api } @case ('Live metal') { Live metal } } You may update it manually or try again later.
        </p>
        }
      </div>
      } @if(!fromSetup){
      <div class="mb-5">
        <button
          [class]="premiumForm.valid ? 'app__btn--primary mb-0 mt-5 rounded-lg' : 'app__btn--disabled mb-0 mt-5 rounded-lg'"
          (click)="premiumForm.valid ? submitForm() : null"
        >
          Save
        </button>
      </div>
      }
    </form>
  </div>
</div>
